import {computed, _} from '@api'
import {CatalogItemSidebarDetailsStore} from '@modules'
import {ModalSectionRows} from '@stores'
import {observable, reaction} from 'mobx'

export class SidebarTableRowStore {
  private originalData: Array<any> = []
  constructor(public detailsStore: CatalogItemSidebarDetailsStore, public rows: ModalSectionRows, public secItemSource: string) {
    detailsStore.adoptionStore = this
  }

  registerEffects = () => {
    const dispose = [
      reaction(() => this.adoptions, (d) => {
        if (d?.length === 0) {
          this.originalData = d
        }
      })
    ]

    return () => dispose.forEach(f => f())
  }

  @computed get itemSource() {
    const {detailsStore: {sidebar: {selectedTab, type}, detailDef}, secItemSource} = this,
      activeTab = (type !== 'modal') ? {itemSource: secItemSource} : detailDef?.modal?.tabs.find(t => t.id == selectedTab)
    return activeTab?.itemSource ?? ''
  }

  @computed get adoptions() {
    const {itemSource, detailsStore: {data}} = this
    return data ? _.get(data, itemSource) : []
  }

  @computed get dataById() {
    return _.keyBy(this.adoptions, 'exId')
  }

  updateAdoptionsData = (id: string, field: string, value: any) => {
    const {dataById} = this
    _.set(dataById[id], field, value)
  }

  @observable isDirty = false

  // @computed get isDirty(): boolean {
  //   const {originalData, adoptions} = this,
  //     original = _.cloneDeep(originalData),
  //     updated = _.cloneDeep(adoptions)
  //   if (original?.length && updated?.length) {
  //     return !_.isEqual(original, updated)
  //   }
  //   return false
  // }

  @computed get changedValues() {
    return this.adoptions
  }
}


// WEBPACK FOOTER //
// ./src/modules/drawer/stores/SidebarTableRowStore.ts